<template>
  <div class="ws-easy-table__content-item">
    <div class="ws-easy-table__content-title">{{field.label}}</div>
    <div class="ws-easy-table__content-content">
      <WsInfo
        :type="field.type"
        :fields="field.fields"
        :items="field.items"
        :textKey="field.textKey"
        :relationPopup="field.relationPopup"
        :value="value"
        :modelName="field.modelName"
        :activeText="field.activeText"
        :inactiveText="field.inactiveText"
        :getText="field.getText"
        :originData="modelData"
        :multiple="field.multiple"
      ></WsInfo>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    modelName: {
      type: String,
      default: null,
    },
    field: Object,
    value: {},
    modelData: {
      type: Object,
      default: null
    }
  },
};
</script>

<style>
</style>